import { IconName } from '@curology/ui-components-web/react';
import { NavBannerProps } from '..';

export const FREE_GIFT_BANNER_CONTENT: NavBannerProps = {
  iconName: IconName.Gift,
  text: 'FREE gift (up to $52 value!) when you subscribe today',
};
